<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <OnRHList :fss=fss :rliss="rliss" ></OnRHList>
      </div>
    </div>
  </div>
</template>

<script>

// Ce fichier est encore en développement, et non utilisé

import OnRHList from '@/components/rh/rhList.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: [],
    rliss: []
  }},

  name: 'OnRH',
  components: {
    OnRHList,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/rh_list.php',
          { })
        .then(response => {
          this.fss = response.data.fss;
          this.rliss = response.data.rliss;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
